import * as React from 'react';
import { Moveable } from './moveable';
import { IMakeMoveableProps, IMoveableProps } from './moveable-types';

export function makeMoveable<TContext = {}, TProps = {}, TRef = any>(Component: React.ComponentType<TProps>, mapRef: (ref: React.RefObject<TRef>) => Partial<TProps>) {

    type IMoveableWrappedProps = TProps & { moveable: IMakeMoveableProps<TContext> };
    const MadeMoveable = ((props: IMoveableWrappedProps) => {
        const _onRender = React.useCallback((ref) => (
            <Component {...props} {...mapRef(ref as any)} />
        ), [props]);
        return React.createElement(Moveable, props.moveable as IMoveableProps, _onRender);
    }) as React.ComponentType<IMoveableWrappedProps>;
    MadeMoveable.displayName = `makeMoveable(${Component.displayName ?? Component.name})`;
    return MadeMoveable;
}
